import React, { useEffect, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import tw from 'twin.macro';
import { RouterContext, AppContext } from '../context';

export const SlideInMenu = ({ isLeft }) => {
  const {
    imageSlider,
    slideIn,
    slideIn: { active, fullwidth, Component },
    setSlideIn,
  } = useContext(AppContext);
  const route = useContext(RouterContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const modalId = searchParams.get('selectedId');
  const isItemModal = !!modalId;

  const handleClickOutside = (e) => {
    if (e.target.dataset.type === 'overlay' && !imageSlider.active) {
      if (isItemModal) {
        setSearchParams({});
      }
      setSlideIn({ fullwidth: false, active: false, Component: () => <></> });
    }
  };

  const onKeyUp = (e) => {
    if (e.keyCode === 27 && !imageSlider.active) {
      if (isItemModal) {
        setSearchParams({});
      }
      setSlideIn({ fullwidth: false, active: false, Component: () => <></> });
    }
  };

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keyup', onKeyUp);
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('keyup', onKeyUp);
        document.removeEventListener('click', handleClickOutside);
      };
    } else {
      document.body.style.overflow = '';
    }
  }, [Object.values(route).join(), active, imageSlider]);

  return (
    <div
      css={[
        active &&
          tw`absolute w-screen h-screen z-50 flex justify-center items-center bg-secondary bg-opacity-80 backdrop-blur-lg
      md:top-14 md:h-[calc(100vh-56px)]`,
        fullwidth && tw`md:top-0 md:h-[calc(100vh)]`,
      ]}
      data-type='overlay'
    >
      <div
        css={[
          tw`absolute inset-0 m-auto bg-secondary transition transition-transform
        duration-200 z-50 rounded-xl flex flex-col min-w-[340px]`,
          !isLeft && tw`translate-x-full`,
          isLeft && tw`-translate-x-full`,
          active && tw`translate-x-0`,
          !fullwidth &&
            tw`bg-primary sm:p-0 w-full rounded-none sm:rounded-xl sm:h-5/6 sm:w-[600px] flex-col`,
          fullwidth &&
            tw`bg-primary p-0 h-full transition-max-width duration-500 mx-auto rounded-none 
        lg:pb-2 lg:w-full xl:p-0 xl:container xl:rounded-xl xl:h-[100vh]`,
        ]}
      >
        <Component slideIn={slideIn} setSlideIn={setSlideIn} modalId={modalId} />
      </div>
    </div>
  );
};
